import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardContent';
import React from 'react';
import SimpleImageLoader from '../Atoms/SimpleImageLoader';
import Typography from '@material-ui/core/Typography';
import useGlobalStyles from '../../styles/globalStyles';
import useStyles from './styles';
import ImageSelectionAndCropper from "../Organisms/ImageSelectionAndCropper";

interface IEventHeroProps {
    heroImage: string;
    saveEventHeroImage: Function;
}

const EventHero = ({ heroImage, saveEventHeroImage }: IEventHeroProps) => {
    const classes = useStyles();
    const globalClasses = useGlobalStyles();
    const handleFileSelect = (res: any) => {
        saveEventHeroImage(res);
    };
    return (
        <Card className={classes.card}>
            <CardHeader classes={{ root: globalClasses.cardHeader }}>
                <Typography variant="h5">Event Hero Image</Typography>
            </CardHeader>
            <CardContent>
                {heroImage && <SimpleImageLoader alt={`hero image`} src={heroImage} width={300} />}
                <ImageSelectionAndCropper handleFileSelection={handleFileSelect} aspectRatio={12/5} launchBrowserButtonText={'Change Event Hero Image'} recommended={{width:2400, height:1000}} />
            </CardContent>
        </Card>
    );
};

export default EventHero;
